<script lang="ts">import { cfgToThemeCdnPath } from "@infinitro/config";
import { t, Verbiage } from "@infinitro/content";
import VipBenefitSection from "./vip-benefit-section.svelte";
const rewardKeys = [{
	titleKey: "rakeback",
	image: cfgToThemeCdnPath("/about-vip/rakeback.png")
}, {
	titleKey: "rakeboost",
	image: cfgToThemeCdnPath("/about-vip/rakeboost.png")
}];
</script>

<VipBenefitSection
	title={$t(Verbiage.vip_alt2_rakeback_perks)}
	description={$t(Verbiage.vip_alt2_rakeback_description)}
	rewards={rewardKeys.map((r) => ({ title: $t(Verbiage[r.titleKey]), image: r.image }))}
/>
